module.exports = __webpack_public_path__ + "static/media/AboutMeImage38.4d8e5c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AboutMeImage38.png
// module id = 77
// module chunks = 0